type SetToken = (access: string, refresh?: string) => void;

/**
 * token setting 후 auth event 발생
 * @param access accessToken 값
 * @param refresh refreshToken 값 (optional)
 */
const setToken: SetToken = (access, refresh) => {
	window.localStorage.setItem('accessToken', access);
	if (refresh) window.localStorage.setItem('refreshToken', refresh);
	window.dispatchEvent(new Event('auth'));
};

/**
 * token 삭제 후 auth 이벤트 발생
 */
const removeToken = () => {
	window.localStorage.removeItem('accessToken');
	window.localStorage.removeItem('refreshToken');
	window.sessionStorage.removeItem('nav-type');
	window.dispatchEvent(new Event('auth'));
	// React Query 캐시 초기화를 위한 이벤트 발생
	window.dispatchEvent(new Event('reset-query-cache'));
};

export { setToken, removeToken };
